import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap"
import { AvForm, AvField } from 'availity-reactstrap-validation';
import AreaService from "services/Provider/AreaServic";
import Select from "react-select";
import { SuccessOk } from "configs/statusCode";

const FilterModal = ({ filterModal, setFilterModal, updateFiltersData, locationData }) => {
    const areaService = new AreaService()
    const [areaOptions, setAreaOptions] = useState([])
    const [formData, setFormData] = useState({
        area: ''
    })

    useEffect(() => {
        areaService.getAreaDropDown().then(res=>{
            if(res.status == SuccessOk){
                const newOptions = res.data.map(item => {
                    return {
                        label: item.name.en ?item.name.en :item.name,
                        value: item.id
                    }
                })
                setAreaOptions(newOptions)
            }
        })
    }, [])

    return (
        <AvForm className='form-horizontal'  >
            <Modal isOpen={filterModal} toggle={() => setFilterModal(!filterModal)}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={() => setFilterModal(!filterModal)}>
                    Resale Filters
            </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}  >
                            <label>Location</label>
                            <Select
                                placeholder='Select'
                                options={areaOptions}
                                onChange={(data) => {
                                    setFormData({ ...formData, area: data });
                                }}
                                value={formData.area}
                            />
                        </Col>

                    </Row>
                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            setFormData({...formData, area: ''})
                            updateFiltersData("")
                        }}>
                        Reset Filter
                     </button>
                    <button
                        type="button"
                        onClick={() => {
                            if (formData.area !== '') {
                                updateFiltersData(formData.area.label)
                                setFilterModal(!filterModal)
                            } else {
                                updateFiltersData('')
                                setFilterModal(!filterModal)
                            }
                        }}
                        className='btn btn-success  w-120'>
                        Apply Filter
                    </button>
                </ModalFooter>
            </Modal>
        </AvForm>
    )
}
export default FilterModal